import ShortReview from '~/js/components/global/reviews/ShortReview';
import Slider from 'react-slick';
import LazyLoad from 'react-lazyload';
import ReviewsModal from '~/js/components/global/reviews/ReviewsModal';

const { Component, Fragment } = React;

class ReviewSlider extends Component {

  constructor(props) {
    super(props);

    this.state = {
      clickedReview: false,
      activeModal: {},
      currentSlide: 0,
      showMore: false
    };

    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }

  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }

  _enableUrlModal = (resortObj) => {
    document.querySelector('body').classList.add('prevent-scroll');
    this.setState({
      activeModal: resortObj,
      showMore: true
    });
  }

  _enableModal = (resortObj) => {
    document.querySelector('body').classList.add('prevent-scroll');
    this.setState({
      clickedReview: true,
      activeModal: resortObj,
      showMore: true
    });
  }

  _disableModal = () => {
    document.querySelector('body').classList.remove('prevent-scroll');
    this.setState({
      clickedReview: false,
      activeModal: {},
      showMore: false
    });
  };

  render() {
    const { currentSlide, showMore, activeModal, clickedReview } = this.state;
    const { reviews, urlReviews } = this.props;

    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      centerMode: true,
      focusOnSelect: false,
      centerPadding: 0,
      slidesToShow: 3,
      slidesToScroll: 1,
      rows: 1,
      arrows: false,
      variableWidth: false,
      beforeChange: (current, next) => this.setState({ currentSlide: next }),
      responsive: [
        {
          breakpoint: 991,
          settings: {
            variableWidth: true,
            slidesToShow: 1,
            centerMode: true,
          }
        },
        {
          breakpoint: 767,
          settings: {
            variableWidth: true,
            slidesToShow: 1,
            centerMode: false
          }
        }
      ]
    };

    return (
      <Fragment>
        <Slider ref={c => (this.slider = c)} {...settings}>
          {reviews.map((review, index) => {
            return (
              <ShortReview
                enableUrlModal={this._enableUrlModal}
                enableModal={this._enableModal}
                key={`${index}-${review.resortCode}`}
                review={review}
                index={index}
                currentSlide={currentSlide}
                urlReviews={urlReviews}
              />
            );
          })}
        </Slider>
        <div className="slick-nav">
          <button onClick={this.previous} className="slick-arrow slick-prev grs-arrow grs-prev"><i className="icon-button-arrow-prev"/></button>
          <div className="slick-counter">{`${currentSlide + 1}/${this.props.reviews.length}`}</div>
          <button onClick={this.next} className="slick-arrow slick-next grs-arrow grs-next"><i className="ic icon-button-arrow-next"/></button>
        </div>

        {showMore && (
          <ReviewsModal
            clickedReview={clickedReview}
            disableModal={this._disableModal}
            urlReviews={urlReviews}
            resort={{
              id: activeModal.id,
              body: activeModal.body,
              code: activeModal.resortCode,
              name: activeModal.resortName,
              country: activeModal.resortCountry,
              city: activeModal.resortCity,
              url: activeModal.resortUrl,
              images: activeModal.resortImages
            }}
          />
        )}
      </Fragment>
    );
  }


}

export default ReviewSlider;
